import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DEFAULT_BRAND_LOGO } from '../../../config/api';
import NavMenu from './NavMenu';
import LanguageSelector from '../../../locales/LanguageSelector';
import '../MobileNav/MobileNav.css';
import './Navbar.css';

const MobileNavDrawer = ({ isOpen, onClose, logoUrl, callLink, officeNumber }) => {
  const { t } = useTranslation();
  const phoneHref = callLink ? `tel:${callLink}` : '/contact';

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener('keydown', handleEscape);
    }

    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  return (
    <>
      <button
        type="button"
        className={`tps-navbar__overlay${isOpen ? ' is-open' : ''}`}
        aria-label="Close menu"
        onClick={onClose}
      />
      <aside
        className={`tps-navbar__drawer${isOpen ? ' is-open' : ''}`}
        aria-hidden={!isOpen}
        id="offcanvasHome"
      >
        <div className="mr_menu_02">
          <button
            type="button"
            className="mr_menu_02_close"
            onClick={onClose}
            aria-label="Close menu"
          >
            <i className="ion-android-close" />
          </button>

          <div className="logo">
            <Link to="/" onClick={onClose}>
              <img src={logoUrl || DEFAULT_BRAND_LOGO} alt="TPS logo" />
            </Link>
          </div>

          <nav className="mr_navmenu" aria-label="Mobile navigation">
            <NavMenu variant="mobile" onNavigate={onClose} />
          </nav>

          <div className="tps-navbar__drawer-footer">
            <div className="tps-navbar__drawer-lang">
              <LanguageSelector />
            </div>
            {officeNumber ? (
              <a href={phoneHref} className="tps-navbar__drawer-phone" onClick={onClose}>
                <i className="fa fa-phone" aria-hidden="true" />
                <span>{officeNumber}</span>
              </a>
            ) : null}
            <Link to="/contact" className="tps-navbar__drawer-cta" onClick={onClose}>
              {t('RequestQuote')}
            </Link>
          </div>
        </div>
      </aside>
    </>
  );
};

export default MobileNavDrawer;
